<template>
  <div>
    <Breadcrumbs main="Widgets" title="General" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header py-3 px-4">
              <div class="d-flex">
                <h6 class="mb-0" style="flex: 1">Filter Data</h6>

                <ul class="list-unstyled card-option">
                  <li>
                    <a
                      ><i
                        class="fa fa-chevron-down"
                        v-b-toggle.filter
                        style="cursor: pointer"
                      ></i
                    ></a>
                  </li>
                </ul>

                <!--  -->
              </div>
            </div>
            <div class="card-body py-1 px-4">
              <div class="mb-2">
                <b-collapse id="filter" visible role="tabpanel">
                  <div class="row">
                    <div class="col-3">
                      <div class="col-form-label">
                        Department <span class="text-danger">*</span>
                      </div>
                      <multiselect
                        v-model="filter.departement"
                        :options="options.departemen"
                        label="name"
                        @select="roleModel"
                        :searchable="false"
                        :show-labels="false"
                        placeholder="(All)"
                      ></multiselect>
                    </div>

                    <div class="col-3">
                      <div class="col-form-label">
                        Role <span class="text-danger">*</span>
                      </div>
                      <multiselect
                        v-model="filter.role"
                        :options="options.role"
                        label="name"
                        :searchable="false"
                        :close-on-select="false"
                        :show-labels="false"
                        placeholder="(All)"
                      ></multiselect>
                    </div>

                    <div class="col-3">
                      <div class="col-form-label">Tanggal Mulai</div>
                      <datepicker
                        input-class="datepicker-here form-control digits"
                        v-model="filter.dateStart"
                      ></datepicker>
                    </div>

                    <div class="col-3">
                      <div class="col-form-label">Tanggal Akhir</div>
                      <datepicker
                        input-class="datepicker-here form-control digits"
                        v-model="filter.dateEnd"
                      ></datepicker>
                    </div>

                    <div class="col-3">
                      <div class="col-form-label">Source</div>
                      <multiselect
                        v-model="filter.source"
                        :options="options.source"
                        label="name"
                        :searchable="false"
                        :close-on-select="false"
                        :show-labels="false"
                        placeholder="(All)"
                      ></multiselect>
                    </div>

                    <div class="col-3">
                      <div class="col-form-label">Education</div>
                      <multiselect
                        v-model="filter.education"
                        :options="options.education"
                        label="university"
                        :searchable="true"
                        :close-on-select="true"
                        :show-labels="false"
                        placeholder="(All)"
                      ></multiselect>
                    </div>

                    <div class="col-3">
                      <div class="col-form-label">Candidate Name</div>
                
                      <multiselect
                        :isLoading="isLoading"
                        v-model="filter.candidate"
                        :options="options.candidate"
                        label="fullname"
                        :searchable="true" 
                        :close-on-select="true"
                        :show-labels="false"
                        @search-change="asyncFind"
                        placeholder="(All)"
                      ></multiselect>
                    </div>

                    <div class="col-3">
                      <div class="col-form-label">
                        Job Preference Assessment
                      </div>
                      <multiselect
                        v-model="filter.job_preference"
                        :options="options.jobPreference"
                        label="name"
                        :searchable="false"
                        :close-on-select="true"
                        :show-labels="false"
                        placeholder="(All)"
                      ></multiselect>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-xl-6 col-md-6 box-col-6"
          v-for="(data, idx) in dataChartData"
          :key="idx"
        >
          <div class="card">
            <div class="widget-feedback card-body p-2 pb-3 pt-3">
              <!-- <div class="text-center">chart put here</div> -->
              <div id="donutchart">
                <div class="row">
                  <v-chart class="chart" :option="data" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12">
          <px-card :actions="false">
            <div class="p-4">
              <b-row>
                <b-col xl="6" class="d-flex mb-3">
                  <h6 class="mb-0" style="flex: 1; align-self: center">
                    List Candidate
                  </h6>
                </b-col>

                <b-col xl="6" class="text-right mb-3">
                  <b-button
                    id="default-sm-primary "
                    class="mr-2"
                    style="color:#000"
                    variant="warning"
                    @click="downloadHandlePdf()"
                    size="sm"
                    >Download PDF</b-button
                  >

                  <b-button
                    id="default-sm-primary "
                    variant="primary"
                    @click="downloadHandle()"
                    size="sm"
                    >Download Excel</b-button
                  >
                </b-col>

                <b-col xl="12">
                  <div class="table-responsive datatable-vue">
                    <b-table
                      show-empty
                      :items="items"
                      :fields="tablefields"
                      :filter="filter"
                      :current-page="currentPage"
                      :per-page="perPage"
                      @filtered="onFiltered"
                    >
                      <template v-slot:cell(profile)="data">
                        <img
                          :src="getImgUrl(data.item.profile)"
                          class="rounded-circle img-30 mr-3"
                          :alt="data.item.profile"
                        />
                      </template>

                      <template v-slot:cell(internal)="row">
                        {{ row.item.internal }}%
                      </template>

                      <template v-slot:cell(external)="row">
                        {{ row.item.external }}%
                      </template>

                      <template v-slot:cell(action)="row">
                        <div class="btn-showcase">
                          <b-button
                            id="default-sm-primary"
                            variant="primary"
                            @click="detailUser(row.item.id_user)"
                            size="sm"
                            >Detail</b-button
                          >
                          <b-dropdown
                            text="Report"
                            variant="secondary"
                            size="sm"
                          >
                            <b-dropdown-item @click="detailPdf(row.item.id)"
                              >Report PDF</b-dropdown-item
                            >
                            <b-dropdown-item @click="downloadSurvey(row.item.link)">Hasil Survey</b-dropdown-item>
                          </b-dropdown>
                        </div>
                      </template>
                    </b-table>
                  </div>
                </b-col>
                <b-col xl="6">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    class="my-0"
                  ></b-pagination>
                </b-col>

                <b-col xl="6">
                  <b-form-group
                    label-cols="2"
                    label="Per Page"
                    class="mb-0 datatable-select"
                  >
                    <b-form-select
                      v-model="perPage"
                      :options="pageOptions"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </px-card>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import moment from "moment";
import "swiper/dist/css/swiper.css";
import Multiselect from "vue-multiselect";
import Datepicker from "vuejs-datepicker";
import {
  getDataDemografis,
  getDataDepartemen,
} from "../../_services/data.service";

export default {
  name: "GeneralWidgets",
  components: {
    Multiselect,
    Datepicker,
  },
  data() {
    return {
      donutchart: [],
      dataChartData: [],
      dataClass: [],
      isLoading: false,
      options: {
        source: [],
        departemen: [],
        role: [],
        education: [],
        candidate: [],
        jobPreference: [
          {
            name: 'Executor',
            value: 'executor'
          },
          {
            name: 'Thinkers',
            value: 'thinkers'
          },
          {
            name: 'Creators',
            value: 'creators'
          },
          {
            name: 'Philanthropist',
            value: 'philanthropist'
          },
          {
            name: 'Persuaders',
            value: 'persuaders'
          },
          {
            name: 'Organizers',
            value: 'organizers'
          }
        ],
      },
      role: "",
      tablefields: [
        { key: "name", label: "Name", sortable: true },
        { key: "internal", label: "Role Model Internal", sortable: true },
        { key: "external", label: "Role Model External", sortable: true },
        { key: "action", label: "Action", sortable: true },
      ],
      demografis: {
        education: [],
      },
      items: [],
      filter: {
        education: null,
        source: null,
        departement: null,
        role: null,
        candidate: null,
        competency: null,
        likehood: null,
        job_preference: null,
        dateStart: null,
        dateEnd: null,
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
    };
  },
  watch: {
    role() {
      // this.dataChart();
      // this.dataCandidate();
    },
    filter: {
      handler() {
        if (this.filter.departement && this.filter.role) {
          this.dataChart(this.filter);
          this.dataCandidate(this.filter);
        }
      },
      deep: true,
    },
  },
  async mounted() {
    // this.roleModel();
    this.fetchDepartemen();
    this.totalRows = this.items.length;
    let dataDemografis = await getDataDemografis();
    this.options.education = dataDemografis.education;
  },
  methods: {
    async asyncFind (query) {
      this.isLoading = true
      await this.$store.dispatch("match_scoring/getDataCandidateFilter", {
          search: query
        }).then((res) => {
          this.options.candidate = res.data;
          this.isLoading = false;
        });
      
    },
    async dataChart(params) {
      let data = [];
      if (params) {
        data = await this.$store.dispatch("match_scoring/getDataChart", {
          role: this.role.id,
          byEducation: this.filter.education
            ? this.filter.education.university
            : "false",
          byDateStart: this.filter.dateStart ? moment(this.filter.dateStart).format('YYYY-MM-DD') : null,
          byDateEnd: this.filter.dateEnd ? moment(this.filter.dateEnd).format('YYYY-MM-DD') : null,
          byJobPreference: this.filter.job_preference
            ? this.filter.job_preference.value
            : "false",
          byCandidateId: this.filter.candidate
            ? this.filter.candidate.id
            : "false",
        });
      } else {
        data = await this.$store.dispatch("match_scoring/getDataChart", {
          role: this.role.id,
          byjobPreference: this.filter.job_preference
            ? this.filter.job_preference.value
            : "false",
          byDateStart: this.filter.dateStart,
          byDateend: this.filter.dateEnd,
        });
      }
      this.dataChartData = [];

      for (const key in data.data) {
        if (Object.hasOwnProperty.call(data.data, key)) {
          const element = data.data[key];
          let option = {
            title: {
              text: key,
              left: "center",
            },
            series: [
              {
                type: "gauge",
                center: ["50%", "60%"],
                startAngle: 200,
                endAngle: -20,
                min: 0,
                max: 100,
                splitNumber: 10,

                progress: {
                  show: true,
                  width: 30,
                },
                pointer: {
                  show: false,
                },
                axisLine: {
                  lineStyle: {
                    width: 30,
                  },
                },
                axisTick: {
                  distance: -45,
                  splitNumber: 5,
                  lineStyle: {
                    width: 2,
                    color: "#999",
                  },
                },
                splitLine: {
                  distance: -52,
                  length: 14,
                  lineStyle: {
                    width: 3,
                    color: "#999",
                  },
                },
                axisLabel: {
                  distance: -20,
                  color: "#999",
                  fontSize: 20,
                },
                anchor: {
                  show: false,
                },
                title: {
                  show: false,
                },
                detail: {
                  valueAnimation: true,
                  width: "60%",
                  lineHeight: 40,
                  borderRadius: 8,
                  offsetCenter: [0, "-10%"],
                  fontSize: 60,
                  fontWeight: "bolder",
                  formatter: "{value}%",
                  color: "auto",
                },
                data: [
                  {
                    value: element.avg,
                  },
                ],
              },
              {
                type: "gauge",
                center: ["50%", "60%"],
                startAngle: 200,
                endAngle: -20,
                min: 0,
                max: 100,
                progress: {
                  show: true,
                  width: 8,
                },
                pointer: {
                  show: false,
                },
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  show: false,
                },
                detail: {
                  show: false,
                },
                data: [
                  {
                    value: element.avg,
                  },
                ],
              },
            ],
          };

          this.dataChartData.push(option);
        }
      }
    },
    downloadHandlePdf() {
      let payload = {
          role: this.role.id,
          byDateStart: this.filter.dateStart ? moment(this.filter.dateStart).format('YYYY-MM-DD') : null,
          byDateEnd: this.filter.dateEnd ? moment(this.filter.dateEnd).format('YYYY-MM-DD') : null,
          byJobPreference: this.filter.job_preference
            ? this.filter.job_preference.value
            : "false",
          byEducation: this.filter.education
            ? this.filter.education.university
            : "false",
          byCandidateId: this.filter.candidate
            ? this.filter.candidate.id
            : "false",
          paginate: true,
          pageLimit: this.perPage,
        };
      window.open(`${process.env.VUE_APP_API_URL}/report/download-pdf?role=${payload.role}&byDateStart=${payload.byDateStart}&byDateEnd=${payload.byDateEnd}&byJobPreference=${payload.byJobPreference}&byEducation=${payload.byEducation}&byCandidateId=${payload.byCandidateId}`);
    },
    downloadHandle() {
      window.open(`${process.env.VUE_APP_API_URL}/report/download-excel`);
    },
    detailPdf(id) {
      window.open(
        `${process.env.VUE_APP_API_URL}/report/general-report?id=${id}`
      );
    },
    downloadSurvey(link){
      if(link){
        window.open(
          link
        );
      }else{Attachment
        this.$swal({
          title:'Info',
          text:'Link Not Found',
          type:'info'
        });
      }
    },
    async dataCandidate(params) {
      var data = [];
      if (params) {
        data = await this.$store.dispatch("match_scoring/getDataCandidate", {
          role: this.role.id,
          byDateStart: this.filter.dateStart ? moment(this.filter.dateStart).format('YYYY-MM-DD') : null,
          byDateEnd: this.filter.dateEnd ? moment(this.filter.dateEnd).format('YYYY-MM-DD') : null,
          byJobPreference: this.filter.job_preference
            ? this.filter.job_preference.value
            : "false",
          byEducation: this.filter.education
            ? this.filter.education.university
            : "false",
          byCandidateId: this.filter.candidate
            ? this.filter.candidate.id
            : "false",
          paginate: true,
          pageLimit: this.perPage,
        });
      } else {
        data = await this.$store.dispatch("match_scoring/getDataCandidate", {
          role: this.role.id,
          byDateStart: this.filter.dateStart ? moment(this.filter.dateStart).format('YYYY-MM-DD') : null,
          byDateEnd: this.filter.dateEnd ? moment(this.filter.dateEnd).format('YYYY-MM-DD') : null,
          byJobPreference: this.filter.job_preference
            ? this.filter.job_preference.value
            : "false",
          byEducation: this.filter.education
            ? this.filter.education.university
            : "false",
          byCandidateId: this.filter.candidate
            ? this.filter.candidate.id
            : "false",
          paginate: true,
          pageLimit: this.perPage,
        });
      }

      this.items = data.data.data;
      this.totalRows = data.total_data_request;
      this.currentPage = data.data.data.current_page;
      this.perPage = data.data.data.per_page;
    },
    async roleModel(departement) {
      let role = await this.$store.dispatch(
        "match_scoring/getDataRoleModel",
        departement.id
      );
      this.options.role = role.data;
      this.role = role.data[0];

      // this.dataChart();
      // this.dataCandidate();
    },
    async fetchDepartemen() {
      let departemen = await getDataDepartemen();
      this.options.departemen = departemen;
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getImgUrl() {
      let idx = Math.floor(Math.random() * 10);
      return require("../../assets/images/user/" +
        (idx == 0 ? 1 : idx) +
        ".jpg");
    },
    detailUser(id_user) {
      this.$router.push({
        path: "/user",
        query: {
          id_user: id_user,
        },
      });
    },
  },
};
</script>

<style scoped>
.chart {
  height: 400px;
}
</style>
